export var ceilToNearest = function ceilToNearest(n, to) {
  return Math.ceil(n / to) * to;
};